import { render } from "./refresh.vue?vue&type=template&id=0b5554f8&ts=true"
import script from "./refresh.vue?vue&type=script&lang=ts"
export * from "./refresh.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__